import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './AcademyMenu.module.css';

const AcademyMenu = props => {
  return (
    <nav className={classes.academyMenuContainer}>
      <ul className={classes.menu}>
        {props.menu.map(item => (
          <li className={classes.item} key={item.id}>
            <Button
              className={classes.itemLink}
              variant="text"
              component="a"
              href={item.url}
            >
              {item.menuName}
            </Button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

AcademyMenu.propTypes = {
  // eslint-disable-next-line react/require-default-props
  menu: PropTypes.array
};

export default AcademyMenu;
